import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { CookieConsentProvider } from './components/CookieConsent';
import { Layout } from './components/Layout';
import { AuthProvider } from './context/AuthContext';
import { LandingPage } from './pages/LandingPage';
import { HomeScan } from './pages/HomeScan';
import { Bedankt } from './pages/Bedankt';
import { RapportPage } from './pages/RapportPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { CookiesPage } from './pages/CookiesPage';
import { HelpPage } from './pages/HelpPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { PricingPage } from './pages/PricingPage';
import { ContactPage } from './pages/ContactPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { AccountPage } from './pages/AccountPage';
import { PurchaseDetailPage } from './pages/PurchaseDetailPage';
import { AdminPage } from './pages/AdminPage';
import { FaqPage } from './pages/FaqPage';
import { AboutPage } from './pages/AboutPage';
import { BlogIndexPage } from './pages/BlogIndexPage';
import { BlogArticlePage } from './pages/BlogArticlePage';
import { TroubleshootingPage } from './pages/TroubleshootingPage';
import { ReviewsPage } from './pages/ReviewsPage';
import { DisclaimerPage } from './pages/DisclaimerPage';
import { OrderTermsPage } from './pages/OrderTermsPage';
import { PaymentMethodsPage } from './pages/PaymentMethodsPage';
import { DemoPage } from './pages/DemoPage';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CookieConsentProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<LandingPage />} />
              <Route path="/scan" element={<HomeScan />} />
              <Route path="/demo" element={<DemoPage />} />
              <Route path="/project" element={<Navigate to="/scan" replace />} />
              <Route path="/bedankt" element={<Bedankt />} />
              <Route path="/rapport" element={<RapportPage />} />
              <Route path="/inloggen" element={<LoginPage />} />
              <Route path="/registreren" element={<RegisterPage />} />
              <Route path="/wachtwoord-vergeten" element={<ForgotPasswordPage />} />
              <Route path="/wachtwoord-reset" element={<ResetPasswordPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/account/aankopen/:id" element={<PurchaseDetailPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/voorwaarden" element={<TermsPage />} />
              <Route path="/cookies" element={<CookiesPage />} />
              <Route path="/help" element={<HelpPage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/over-ons" element={<AboutPage />} />
              <Route path="/kennisbank" element={<BlogIndexPage />} />
              <Route path="/kennisbank/:slug" element={<BlogArticlePage />} />
              <Route path="/troubleshooting" element={<TroubleshootingPage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/disclaimer" element={<DisclaimerPage />} />
              <Route path="/bestelvoorwaarden" element={<OrderTermsPage />} />
              <Route path="/prijzen" element={<PricingPage />} />
              <Route path="/betaalmethoden" element={<PaymentMethodsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </CookieConsentProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
